import { render, staticRenderFns } from "./UserMangement.vue?vue&type=template&id=2336c9cc&scoped=true"
import script from "./UserMangement.vue?vue&type=script&lang=ts"
export * from "./UserMangement.vue?vue&type=script&lang=ts"
import style0 from "./UserMangement.vue?vue&type=style&index=0&id=2336c9cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2336c9cc",
  null
  
)

export default component.exports